import type {
  CascaderOption,
  CascaderSubmenu,
} from '@frontend/legacy-components';

export type MaterialCascaderNode = {
  label: unknown;
  value: number | string;
  children?: MaterialCascaderNode[];
  isLeaf?: boolean;
};

const toLabel = (label: unknown): string =>
  typeof label === 'string' ? label : String(label ?? '');

export function adaptMaterialOptionsToCascaderSubmenu(
  materialClasses: MaterialCascaderNode[],
): CascaderSubmenu<CascaderOption> {
  const adaptNode = (node: MaterialCascaderNode): CascaderOption => {
    const base = {
      label: toLabel(node.label),
      value: String(node.value),
    };
    if (!node.children?.length) {
      return base;
    }
    return {
      ...base,
      children: [{ children: node.children.map(adaptNode) }],
    };
  };

  return {
    label: 'Materials',
    value: '__material_root__',
    children: [{ children: materialClasses.map(adaptNode) }],
  };
}
